import { makeStyles } from 'tss-react/mui';
import { ReactNode } from 'react';

interface ContentProps {
    children: ReactNode;
}
const useStyles = makeStyles()(() => ({
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(0, 0, 0, 0.7)',
        zIndex: 1500,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
    },
}));

function Overlay(props: Readonly<ContentProps>) {
    const { classes } = useStyles();
    return <div className={classes.overlay}>{props.children}</div>;
}

export default Overlay;
